import React from "react";
import { PropTypes } from "prop-types";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({
  component: Component,
  render,
  permitted,
  redirectRoute,
  ...rest
}) => {
  const renderFn = routeProps =>
    render ? render(routeProps) : <Component {...routeProps} />;

  return (
    <Route
      {...rest}
      render={props =>
        permitted ? (
          renderFn(props)
        ) : (
          <Redirect
            to={{
              pathname: redirectRoute || "/",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;

PrivateRoute.propTypes = {
  /**
   * True if user has permission to route, false otherwise
   */
  permitted: PropTypes.bool,
  redirectRoute: PropTypes.string,
  component: PropTypes.node,
  render: PropTypes.func
};
